import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Col, Form, Modal, Row, Table} from 'antd';
import {queryAccountOrgOrgs} from '@api/core/user';
import SelectOrg from './SelectOrg';

class IndexModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkedKeys: [],
      selectedItems: [],
      defaultOrgUuid: '',
    };
  }

  componentDidMount() {
    this.loadData(this.props.accountUuid);
    this.setState({ defaultOrgUuid: this.props.defaultOrgUuid });
  }

  componentWillReceiveProps(nextProps) {
    this.props.accountUuid !== nextProps.accountUuid && this.loadData(nextProps.accountUuid);
    this.props.defaultOrgUuid !== nextProps.defaultOrgUuid &&
      this.setState({ defaultOrgUuid: nextProps.defaultOrgUuid });
  }

  loadData = accountUuid => {
    accountUuid &&
      queryAccountOrgOrgs({ accountUuid }).then(res => {
        if (res.statusCode === 200) {
          const checkedKeys = res.data.map(item => item.uuid);
          const { defaultOrgUuid } = this.state;
          if (checkedKeys.includes(defaultOrgUuid)) {
            checkedKeys.push(defaultOrgUuid);
          }
          this.setState({ checkedKeys, selectedItems: res.data });
        }
      });
  };

  submit = () => {
    const { accountUuid } = this.props;
    const { checkedKeys, defaultOrgUuid } = this.state;
    const params = {};
    params.accountUuid = accountUuid;
    params.orgUuids = checkedKeys;
    params.defaultOrgUuid = defaultOrgUuid;
    this.props.onOk(params);
  };

  onCancel = () => {
    this.props.form.resetFields();
    this.props.onCancel();
  };

  setStateCheckedKeys = checkedKeys => {
    this.setState({
      checkedKeys,
    });
  };

  setStateSelectedItems = selectedItems => {
    this.setState({
      selectedItems,
    });
  };

  onChangeDefault = uuid => {
    this.setState({ defaultOrgUuid: uuid });
  };

  columns = defaultOrgUuid => {
    return [
      {
        title: '默认机构名称',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: '操作',
        dataIndex: 'uuid',
        render: (rext, record) => {
          return (
            <span>
              {rext !== defaultOrgUuid ? (
                <a onClick={() => this.onChangeDefault(record.uuid)}>设置默认</a>
              ) : (
                '默认'
              )}
            </span>
          );
        },
      },
    ];
  };

  render() {
    const { accountUuid } = this.props;
    const { checkedKeys, selectedItems, defaultOrgUuid } = this.state;
    return (
      <Modal
        title="机构部门设置"
        visible={this.props.visible}
        onOk={this.submit}
        onCancel={this.onCancel}
        width="750px"
      >
        <Row>
          <Col span={12}>
            <SelectOrg
              accountUuid={accountUuid}
              checkedKeys={checkedKeys}
              selectedItems={selectedItems}
              setStateCheckedKeys={this.setStateCheckedKeys}
              setStateSelectedItems={this.setStateSelectedItems}
            />
          </Col>
          <Col span={12}>
            <Table
              rowKey={record => record.uuid}
              columns={this.columns(defaultOrgUuid)}
              dataSource={selectedItems}
              pagination={false}
            />
          </Col>
        </Row>
      </Modal>
    );
  }
}

export default connect(state => ({
  accountInfo: state.account_info,
}))(Form.create()(IndexModal));



// WEBPACK FOOTER //
// ./src/components/boss/user/ModalUserOrgAdd.js